import React from 'react';

export interface FacebookProps {
  className?: string;
}

const WeatherWindy: React.FC<FacebookProps> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 30 30"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 9C10 7.34315 11.3431 6 13 6C14.6569 6 16 7.34315 16 9C16 10.6569 14.6569 12 13 12H12H4C3.44772 12 3 12.4477 3 13C3 13.5523 3.44772 14 4 14H12H13H22C23.6569 14 25 12.6569 25 11C25 9.34315 23.6569 8 22 8C21.4477 8 21 8.44772 21 9C21 9.55228 21.4477 10 22 10C22.5523 10 23 10.4477 23 11C23 11.5523 22.5523 12 22 12H17.0004C17.6281 11.1643 18 10.1256 18 9C18 6.23858 15.7614 4 13 4C10.2386 4 8 6.23858 8 9C8 9.55228 8.44772 10 9 10C9.55228 10 10 9.55228 10 9ZM19 21C19 22.6569 20.3431 24 22 24C23.6569 24 25 22.6569 25 21C25 19.3431 23.6569 18 22 18H17C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16H22C24.7614 16 27 18.2386 27 21C27 23.7614 24.7614 26 22 26C19.2386 26 17 23.7614 17 21C17 20.4477 17.4477 20 18 20C18.5523 20 19 20.4477 19 21ZM12 22C11.4477 22 11 21.5523 11 21C11 20.4477 11.4477 20 12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18H4C3.44772 18 3 17.5523 3 17C3 16.4477 3.44772 16 4 16H12C13.6569 16 15 17.3431 15 19C15 20.6569 13.6569 22 12 22Z"
        fill="white"
      />
    </svg>
  );
};

export default WeatherWindy;
